import React from "react";


export default function PageNotFound(props) {
	return (
		<div>Page not found</div>
	)
}
